module.exports = __webpack_public_path__ + "static/img/wall.53089a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/graph/wall.png
// module id = uk17
// module chunks = 3